<template>
    <div>
        <h1>Компании</h1>
				<Table
					:columns="columns"
					:data-source="companies"
				>
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'firm_name'">
                    <a :href="'/film_company/'+record.id">{{ record.firm_name }}</a>
                </template>
                <template v-if="column.key === 'actions'">
                    <a class="delete_link" :href="'/company_delete/'+ record.id"><i class="far fa-trash-alt"></i></a>
                </template>

            </template>
				</Table>

    </div>
</template>

<script setup>
import {ref} from "vue";
import axios from "axios";
import { Table } from "ant-design-vue";

let columns = [
  {
    title: 'Название',
    dataIndex: 'firm_name',
    key: 'firm_name',
  },
  {
    title: 'Действия',
    dataIndex: 'actions',
    key: 'actions',
  }
]


let companies = ref([]);
async function getCompanies() {
  const response = await axios.get('/get_film_companies');
  companies.value = response.data;
}
getCompanies();




</script>

<style scoped>

</style>